/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    NotificationType,
    NotificationTypeFromJSON,
    NotificationTypeFromJSONTyped,
    NotificationTypeToJSON,
    RewardType,
    RewardTypeFromJSON,
    RewardTypeFromJSONTyped,
    RewardTypeToJSON,
    WinningCriteria,
    WinningCriteriaFromJSON,
    WinningCriteriaFromJSONTyped,
    WinningCriteriaToJSON,
} from './';

/**
 * 
 * @export
 * @interface NotificationMetadata
 */
export interface NotificationMetadata {
    /**
     * 
     * @type {NotificationType}
     * @memberof NotificationMetadata
     */
    notificationType: NotificationType;
    /**
     * 
     * @type {string}
     * @memberof NotificationMetadata
     */
    nftUri?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMetadata
     */
    mintDate?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMetadata
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMetadata
     */
    guildId?: string;
    /**
     * 
     * @type {WinningCriteria}
     * @memberof NotificationMetadata
     */
    winningCriteria?: WinningCriteria;
    /**
     * 
     * @type {string}
     * @memberof NotificationMetadata
     */
    winnerMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMetadata
     */
    challengeName?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMetadata
     */
    rewardName?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMetadata
     */
    assetId?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMetadata
     */
    challengeEndDate?: string;
    /**
     * 
     * @type {number}
     * @memberof NotificationMetadata
     */
    amount?: number;
    /**
     * 
     * @type {RewardType}
     * @memberof NotificationMetadata
     */
    rewardType?: RewardType;
}

export function NotificationMetadataFromJSON(json: any): NotificationMetadata {
    return NotificationMetadataFromJSONTyped(json, false);
}

export function NotificationMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'notificationType': NotificationTypeFromJSON(json['notificationType']),
        'nftUri': !exists(json, 'nftUri') ? undefined : json['nftUri'],
        'mintDate': !exists(json, 'mintDate') ? undefined : json['mintDate'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'guildId': !exists(json, 'guildId') ? undefined : json['guildId'],
        'winningCriteria': !exists(json, 'winningCriteria') ? undefined : WinningCriteriaFromJSON(json['winningCriteria']),
        'winnerMessage': !exists(json, 'winnerMessage') ? undefined : json['winnerMessage'],
        'challengeName': !exists(json, 'challengeName') ? undefined : json['challengeName'],
        'rewardName': !exists(json, 'rewardName') ? undefined : json['rewardName'],
        'assetId': !exists(json, 'assetId') ? undefined : json['assetId'],
        'challengeEndDate': !exists(json, 'challengeEndDate') ? undefined : json['challengeEndDate'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'rewardType': !exists(json, 'rewardType') ? undefined : RewardTypeFromJSON(json['rewardType']),
    };
}

export function NotificationMetadataToJSON(value?: NotificationMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'notificationType': NotificationTypeToJSON(value.notificationType),
        'nftUri': value.nftUri,
        'mintDate': value.mintDate,
        'description': value.description,
        'guildId': value.guildId,
        'winningCriteria': WinningCriteriaToJSON(value.winningCriteria),
        'winnerMessage': value.winnerMessage,
        'challengeName': value.challengeName,
        'rewardName': value.rewardName,
        'assetId': value.assetId,
        'challengeEndDate': value.challengeEndDate,
        'amount': value.amount,
        'rewardType': RewardTypeToJSON(value.rewardType),
    };
}


